import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

export const OperatingHoursContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));

export const OperatingHoursGrid = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.secondary,
  borderRadius: '8px',
  minWidth: 'fit-content',
}));

export const GridContainer = styled(Box)({
  display: 'grid',
  gridTemplateColumns: '200px repeat(3, 1fr)',
});

export const HeaderRow = styled(Box)({
  display: 'contents',
});

export const HeaderCell = styled(Box)(({ theme }) => ({
  padding: '16px',
  borderBottom: `1px solid ${theme.palette.divider}`,
  borderRight: `1px solid ${theme.palette.divider}`,
  textAlign: 'left',

  '&.first-column': {
    borderLeft: 'none',
  },
  '&.last-column': {
    borderRight: 'none',
  },
  '&.span-2': {
    gridColumn: 'span 2',
    textAlign: 'center',
  },
  '&.span-3': {
    gridColumn: 'span 3',
    textAlign: 'center',
  },
}));

export const HeaderText = styled(Typography)({
  color: '#fff',
  fontSize: '14px',
  fontWeight: 500,
});

export const TimeRow = styled(Box)({
  display: 'contents',
});

export const DayCell = styled(Box)(({ theme }) => ({
  padding: '16px',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  borderBottom: `1px solid ${theme.palette.divider}`,
  borderRight: `1px solid ${theme.palette.divider}`,
  borderLeft: 'none',

  '&.last-row': {
    borderBottom: 'none',
  },
}));

export const TimeCell = styled(Box)(({ theme }) => ({
  padding: '16px',
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  borderBottom: `1px solid ${theme.palette.divider}`,
  borderRight: `1px solid ${theme.palette.divider}`,
  backgroundColor: 'transparent',

  '&.last-column': {
    borderRight: 'none',
  },
  '&.last-row': {
    borderBottom: 'none',
  },
  '&.closed': {
    backgroundColor: theme.palette.divider,
    borderBottom: 'none',
    borderRight: 'none',
    '&:not(:last-child)': {
      borderRight: 'none',
    },
  },
  '&.span-2': {
    gridColumn: 'span 2',
  },
}));

export const TimeSelect = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  color: '#fff',
  '& .MuiTypography-root': {
    fontSize: '14px',
  },
});
